import React from "react";
import { Period } from "../../types";

type GrowthType = {
  percentage: number;
  time?: Period;
};

const defaultProps: GrowthType = { percentage: 0 };

const Growth = ({ percentage, time }: GrowthType): JSX.Element => {
  const CHANGE_COLOR =
    percentage >= 0.2
      ? "text-great"
      : percentage >= 0.1
      ? "text-good"
      : percentage >= 0
      ? "text-normal"
      : percentage <= -0.2
      ? "text-danger"
      : "text-warning";

  return (
    <div className="flex items-center">
      <span className={`${CHANGE_COLOR} mr-2`}>
        <i
          className={
            percentage > 0.05
              ? "fas fa-arrow-up"
              : percentage < -0.05
              ? "fas fa-arrow-down"
              : "fas fa-minus"
          }
        ></i>{" "}
        {Math.round(percentage * 100)}%
      </span>{" "}
      <span>{time}</span>
    </div>
  );
};

Growth.defaultProps = defaultProps;

export default Growth;
